import { Group, Paper, Skeleton, createStyles } from '@ingeniorforeningen/figurine-core';

const style = createStyles((theme) => ({
  header: {
    background: theme.other.colorTokens.backgrounds.primary,
    color: theme.white,
    height: '4.5em',
    width: '100%',
  },
  divider: {
    color: theme.other.colorTokens.dividers.light,
    borderTopColor: theme.other.colorTokens.dividers.light,
  },
}));

const SkeletonDetails = () => {
  const { classes } = style();

  const SkeletonInfo = () => {
    return (
      <Group spacing="xs">
        <Skeleton width="25%" height="1rem" />
        <Skeleton width="100%" height="2.1rem" />
      </Group>
    );
  };

  const SkeletonFile = () => {
    return <Skeleton width="100%" height="2rem" />;
  };

  return (
    <Group style={{ flex: 1 }}>
      <Paper p={0} style={{ overflow: 'hidden', flex: 1 }}>
        <Group className={classes.header} p="xl" noWrap align="center">
          <Skeleton width="50%" height="0" />
        </Group>
        <Group py="sm" direction="column" spacing={0}>
          <Group p="xl" mb="xl" direction="column" spacing="lg">
            <SkeletonInfo />
            <SkeletonInfo />
            <SkeletonInfo />
            <SkeletonInfo />
            <SkeletonInfo />
          </Group>
          <Group pt="xl" px="xl" direction="column" noWrap>
            <Skeleton width="60%" height="2rem" />
          </Group>
          <Group p="xl" direction="column" noWrap align="center" spacing="lg">
            <SkeletonFile />
          </Group>
        </Group>
      </Paper>
    </Group>
  );
};

export default SkeletonDetails;
